<!-- Mobile -->
<ion-item detail="false" lines="none" class="primary ion-margin-vertical ion-hide-sm-up" pointer>
  <ion-avatar slot="start">
    <img
      [src]="avatarPhoto ? avatarPhoto : 'assets/svg/avatar-white.svg'"
      (error)="avatarPhoto = 'assets/svg/avatar-white.svg'"
    />
  </ion-avatar>
  <ion-label>
    <h2 class="text-primary-dark"  [ngClass]="{ bold: bold}" > {{ title }} </h2>
  </ion-label>
</ion-item>
<div class="divider"></div>

<!-- Web -->
<ion-item detail="false" lines="none" class="primary ion-margin-vertical ion-hide-sm-down" pointer>
  <ion-avatar slot="start">
    <img
      [src]="avatarPhoto ? avatarPhoto : 'assets/svg/avatar-white.svg'"
      (error)="avatarPhoto = 'assets/svg/avatar-white.svg'"
    />
  </ion-avatar>
  <ion-label>
    <h2 class="text-primary-dark" [ngClass]="{ bold: bold}"> {{ title }} </h2>
  </ion-label>
  <ion-label>
    <h2 class="text-primary-dark" [ngClass]="{ bold: bold}"> {{ extraInformationOne }} </h2>
  </ion-label>
  <ion-label>
    <h2 class="text-primary-dark" [ngClass]="{ bold: bold}"> {{ extraInformationTwo }} </h2>
  </ion-label>
</ion-item>
